module.exports = __webpack_public_path__ + "static/media/omni-pay.07c02ee1.png";